import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { checkIn } from 'features/accommodation/accommodationSlice'
import useModalClose from 'hooks/useModalClose'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { tokens } from 'styling/tokens'
import { TitleText } from 'styling/Typography'
import { formatDateForDisplay } from 'utils/helpers'

export const ConfirmCheckInModal = ({ closeModal, value }: { closeModal: any, value?: IConfirmCheckInModal }) => {
    const dispatch = useDispatch<AppDispatch>()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(checkIn(value))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal(true)
        }
    }

    const Section = ({ label, value, noBorder }: { label: string, value: string, noBorder?: boolean }) => {
        return <Flex center width='100%' between height='50px' style={{ borderBottom: noBorder ? 'none' : `1px solid ${tokens.border.hairline}` }} >
            <TitleText grey >{label}</TitleText>
            <TitleText>{value}</TitleText>
        </Flex>

    }


    return <Modal black>
        <Flex column between center width='100%'>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Confirm Check-In</TitleText>
                    <CursorPointer onClick={() => closeModal(null)} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex column  >
                    <Section label='Person' value={value.person} />
                    <Section label='ID' value={value?.userId ? String(value.userId) : value.identificationNumber || '/'} />
                    <Section label='Type' value={value.type} />
                    <Section label='Check-in' value={formatDateForDisplay(value.checkIn)} />
                    <Section label='Check-out' value={formatDateForDisplay(value.checkOut)} />
                    <Section label='Bed' value={value.bed} />
                    <Section label='Location' value={value.location} noBorder />
                </Flex>
            </Flex>
            <Button style={{ marginTop: '1rem' }} variant='primary' onClick={handleSave} >Confirm</Button>
        </Flex>
    </Modal>
}

export interface IConfirmCheckInModal {
    id?: string
    bedId?: number
    userId: number
    person: string,
    type: string,
    checkIn: string,
    checkOut: string
    bed: string
    location: string
    complance?: boolean
    identificationNumber?: string
    gender: ISelectValue
}